import { atom } from 'recoil';

import { Auth } from '../interfaces';

const defaultAuthState: Auth = {
  user: undefined,
  authStatus: 'unauthenticated',
  tokenInvitation: undefined,
  parsedPermissions: [],
};

export const authState = atom<Auth>({
  key: 'authState',
  default: defaultAuthState,
});
